// ESM-Huelle um lib/scripts/pos/netcomm/CLS_CHelloAgainAPI.js (Phase 4, Welle 4b).
// Prototype-Stil bleibt vorerst.
// e-Beleg Stufe 2 (tools/E-BELEG.md): gibt es zum Bon einen e-Beleg, geht
// statt der selbstgebauten "MEIN EINKAUF"-Liste der ECHTE Beleg an Hello
// Again - receipt_text (Zeilen wie auf Papier + RKSV-Code + Link),
// metadata.beleg_url und die Beleg-PDF als receipt_pdf_base64. Die PDF haengt
// der Kassenserver an (POST /helloagain mit ebeleg = kasse/receiptId/erstellt),
// sie laeuft nicht durch den Browser (Nutzer 12.10.2026).
import { belegText } from '../receipt/ebeleg.js';

function CHelloAgainAPI(id) {

    //customerID: 1110000000098.1115xxxxxx
    //POST    /receipts/ - API-Key in etc/helloagain-konfig.json (siehe sendReceipt)
    this.debug = 1;
}

// Hello-Again-Kunden haben Kundennummern von 1115000000000 bis unter
// 1120000000000 (Nutzer 28.9.2026; gleiche Grenzen wie rebateengine.js).
// Nur sie werden an Hello Again gemeldet - hauseigene Kunden nicht.
CHelloAgainAPI.prototype.istKunde = function (nummer) {
    var n = Number(nummer);
    return n >= 1115000000000 && n < 1120000000000;
}

// Umlaut-Entitaeten wie im Zentraldienst (pflanze.js klartext): die
// Kassen-DB schreibt sie auch OHNE Strichpunkt ("Gr&uuml;n", "Pfl&uumlck").
var ENTITAETEN = { auml: "\u00e4", ouml: "\u00f6", uuml: "\u00fc", Auml: "\u00c4", Ouml: "\u00d6", Uuml: "\u00dc",
    szlig: "\u00df", amp: "&", quot: "\"", apos: "'", lt: "<", gt: ">", nbsp: " " };
function klartext(t) {
    return String(t || "").replace(/&(auml|ouml|uuml|Auml|Ouml|Uuml|szlig|amp|quot|apos|lt|gt|nbsp);?/g,
        function (m, n) { return ENTITAETEN[n]; })
        .replace(/<br\s*\/?>/gi, " ").replace(/\s+/g, " ").trim();
}

// Warengruppe (Reiter = BTN mit Parent_BTN_ID 0) je Produkt des Bons, fuer
// product_instances[].category. Liefert IMMER ein jQuery-Deferred auf ein
// Objekt { PROD_ID: "Gruppenname" } - bei Fehler oder nach 3 s ein leeres,
// damit die Meldung an Hello Again nie an dieser Abfrage haengen bleibt.
CHelloAgainAPI.prototype.gruppenLaden = function (Entry) {
    var dfd = jQuery.Deferred();
    var ids = [];
    (Entry || []).forEach(function (E) {
        var id = E && E.type == "POS" && Number(E.productId);
        if (id > 0 && ids.indexOf(id) < 0) ids.push(id);
    });
    if (!ids.length || !(window.POS && POS.SQLiteCon)) return dfd.resolve({}).promise();
    var uhr = setTimeout(function () { dfd.resolve({}); }, 3000);
    var sql = "SELECT B1.PROD_ID AS PROD_ID, B2.Text1 AS G1, B2.Text2 AS G2 FROM BTN AS B1 " +
        "LEFT JOIN BTN AS B2 ON B2.BTN_ID = B1.Parent_BTN_ID " +
        "WHERE B2.Parent_BTN_ID = 0 AND B1.PROD_ID IN (" + ids.join(",") + ")";
    try {
        $.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
            var gruppen = {};
            (rows || []).forEach(function (r) {
                if (gruppen[r.PROD_ID]) return;
                var g1 = klartext(r.G1), g2 = klartext(r.G2);
                // "Verkaufs-" + "Material" -> "Verkaufs-Material"
                var name = g2 ? (/-$/.test(g1) ? g1 + g2 : g1 + " " + g2) : g1;
                if (name) gruppen[r.PROD_ID] = name;
            });
            clearTimeout(uhr);
            dfd.resolve(gruppen);
        }, function () {
            clearTimeout(uhr);
            dfd.resolve({});
        });
    } catch (e) {
        clearTimeout(uhr);
        dfd.resolve({});
    }
    return dfd.promise();
}

// Einzelpositionen fuer Hello Again (product_instances, Schema laut
// https://api.helloagain.at/external/docs/swagger/?format=openapi
// "ReceiptUploadProductInstance"): je nicht stornierter POS-Zeile
// Artikelnummer, Name, Einzelpreis, Menge (auch Bruchmengen) + Einheit,
// Zeilensumme nach Rabatt, Warengruppe, Positionsnummer. Rabatte der Zeile
// (referencedBy, negative Betraege) ergeben discount_price (je Einheit) und
// total_price. Punkte werden NICHT je Position gesetzt: sie ergeben sich
// weiter aus "total" (ohne Wertkarten).
CHelloAgainAPI.prototype.produkte = function (Entry, gruppen) {
    var liste = [];
    (Entry || []).forEach(function (E) {
        if (!E || E.type != "POS" || E.cancelled != false) return;
        var menge = Number(E.quantity);
        var betrag = Number(E.amount);
        if (!isFinite(menge) || menge == 0 || !isFinite(betrag)) return;
        var netto = betrag;
        for (var r in E.referencedBy) {
            var ref = E.referencedBy[r];
            if (ref && ref.cancelled == false && isFinite(Number(ref.amount))) netto += Number(ref.amount);
        }
        var name = klartext([E.text1, E.text2].filter(Boolean).join(" ")) || String(E.productId);
        var p = {
            identifier: String(E.productId || (E.product && E.product.ean) || name),
            name: name,
            price: fix2Decimals(E.unitAmount),
            quantity: menge,
            total_price: fix2Decimals(netto),
            position_nr: liste.length + 1
        };
        var einheit = String(E.unit || "").trim();
        if (einheit) p.quantity_unit = einheit;
        if (Math.abs(netto - betrag) >= 0.005) p.discount_price = fix2Decimals(netto / menge);
        var gruppe = gruppen && gruppen[E.productId];
        if (gruppe) p.category = [gruppe];
        if (E.product && E.product.ean) p.attributes = { ean: String(E.product.ean) };
        liste.push(p);
    });
    return liste;
}

CHelloAgainAPI.prototype.createReceipt = function (Entry, Receipt, bontext, custid, eBeleg, gruppen) {

    var total = 0;
    var total_minus = 0;
    // Artikeltexte mit klartext(): in der DB stehen Umlaute als Entitaet
    // ("Gef&aumlrbt") - ohne e-Beleg kam das woertlich bei Hello Again an.
    var bontext = "MEIN EINKAUF\r\n\r\n";
    var grbtext = "";
    var iterator = function it(i) {
        if (i < Entry.length) {
            /*if (Entry[i].type == "POS" && Entry[i].cancelled == false) {
            if (!(Number(Entry[i].unitAmount) < Number(Entry[i].product.price))) { //wenn keine Preisänderung
            total = total + Entry[i].amount;
            }
            } else if (Entry[i].type == "GRB") {
            total = 0;
            return;
            } else if (Entry[i].type.includes("RB")) {
            total = total - Entry[i].reference.amount;
            }*/
            try {
                if (Entry[i] && Entry[i].cancelled == false) {
                    var E = Entry[i];
                    if (E.type == "POS") {
                        bontext = bontext + String(E.quantity + "     ").substr(0, 5) + String(E.unit + "    ").substr(0, 4) + String(klartext(E.text1 + " " + E.text2) + "              ").substr(0, 15) + String("       " + float2StringD2(E.unitAmount)).slice(-7) + String("        " + float2StringD2(E.amount) + " EUR").slice(-12) + "\r\n";
                        E.referencedBy.forEach((ent) => {
                            bontext = bontext + "         " + String(klartext(ent.text1) + "                      ").slice(0, 22) + String("        " + float2StringD2(ent.amount) + " EUR").slice(-12) + "\r\n";
                        })
                        if (E.product && E.product.ean == "VTPPC") { // besser BM.isPPCCharge
                            total_minus = total_minus + Number(E.amount); //keine Punkte bei Wertkarten
                        }
                    } else if (Entry[i].type == "PAY") {
                        total = total + Number(Entry[i].amount);
                    } else if (Entry[i].type == "RET") {
                        total = total - Number(Entry[i].amount);
                    } else if (E.type == 'GRB') { // war "=" (Zuweisung): fing JEDEN Eintrag ab und schrieb seinen Typ auf GRB um
                        grbtext = "         " + String(klartext(E.text1) + "                      ").slice(0, 22) + String("        " + float2StringD2(E.amount) + " EUR").slice(-12) + "\r\n";
                    }
                }
            } catch (error) {
                log.add(1, "Debug B-Kasse", 'Hello again error: ', error);
            }
            iterator(i + 1);
        }
    }
    iterator(0);
    if (grbtext.length > 0)
        bontext = bontext + "\r\n" + grbtext + "\r\n";
    bontext = bontext + "\r\n" + String("Summe:                         ") + String("          " + float2StringD2(total) + " EUR").slice(-12);
    //custid='1115123456789';
    var totalpoints = total - total_minus;

    if (Receipt == null) {
        var d = new Date();
        var dd = d.getDate().toString();
        var hh = d.getHours().toString();
        var min = d.getMinutes().toString();
        var ss = d.getSeconds().toString();
        var yyyy = d.getFullYear().toString();
  	    var mm = (d.getMonth() + 1).toString(); // getMonth() is zero-based
    	mm = (mm[1] ? mm : "0" + mm[0]);
        var datestr = yyyy + "-" + mm + "-" + (dd[1] ? dd : "0" + dd[0]) + "T" + (hh[1] ? hh : "0" + hh[0]) + ":" + (min[1] ? min : "0" + min[0]) + ":" + (ss[1] ? ss : "0" + ss[0]);
        var receiptIdentifier = "WK_"+(Math.random() + 1).toString(36).substring(7);
    } else {
        var datestr = Receipt.datestr;
        var receiptIdentifier = Receipt.receiptIdentifier;
    }

    var receipt = {
        'customer_id': custid,
        //'user_id': '',
        'location_identifier': POS.MasterID,
        //'shop_id': Number(POS.MasterID),
        //'activity_message': '',
        'time_and_date': datestr,
        /*metadata	Metadata{

        }*/
        'receipt_nr': POS.POSId + '_' + receiptIdentifier,
        /*"product_instances":"",	[ReceiptUploadProductInstance{
        identifier*	string
        title: Identifier
        minLength: 1
        name*	string
        title: Name
        minLength: 1
        attributes	Attributes{...}
        price	number
        title: Price
        discount_price	number
        title: Discount price
        quantity	integer
        title: Quantity
        category	[...]
        points	integer
        title: Points
        Can be used to manually calculate the points, or 0 if no points should be awarded for this entry


        }]*/
        "total": totalpoints,
        //"points": 0,
        'receipt_text': eBeleg ? belegText(eBeleg.beleg, eBeleg.url) : bontext,
        /*redeemed_rewards	[
        Which rewards were actually used (previously returned list of activated rewards when starting the transaction

        RedeemedReward{
        description:
        Which rewards were actually used (previously returned list of activated rewards when starting the transaction

        custom_identifier*	string
        title: Custom identifier
        minLength: 1

        }]*/
        //'transaction_id': ''
    }
    if (eBeleg && eBeleg.url)
        receipt.metadata = { beleg_url: eBeleg.url };
    var produkte = this.produkte(Entry, gruppen);
    if (produkte.length)
        receipt.product_instances = produkte;

    return receipt;

}

CHelloAgainAPI.prototype.sendData = function (Entry, Receipt, bontext, custid, callback, defret, eBeleg) {
    var me = this;
    var beleg = eBeleg && eBeleg.beleg ? eBeleg : null;
    // Erst die Warengruppen der Positionen holen (product_instances.category).
    $.when(me.gruppenLaden(Entry)).always(function (gruppen) {
        var hinweis = beleg ? { kasse: beleg.beleg.kasse, receiptId: beleg.beleg.receiptId, erstellt: beleg.beleg.erstellt } : null;
        me.sendReceipt(me.createReceipt(Entry, Receipt, bontext, custid, beleg, gruppen), hinweis);
    });
}

// Versand ueber den LOKALEN Kassenserver (POST /helloagain). Der API-Key
// steht NICHT mehr im Quelltext, sondern nur in etc/helloagain-konfig.json
// der Kasse (gitignoriert); der Kassenserver haengt ihn an. Fehlversuche
// protokolliert der Kassenserver wie bisher in var/log/HelloAgain.log.
// ebeleg ({ kasse, receiptId, erstellt } oder null): der Kassenserver haengt
// die dazu abgelegte PDF als receipt_pdf_base64 an.
CHelloAgainAPI.prototype.sendReceipt = function (DataToSend, ebeleg) {
    var me = this;
    if (me.debug == 1) {
        log.add(1, "Debug B-Kasse", 'send to Hello again: ', JSON.stringify(DataToSend));
    }
    $.ajax({
        url: "helloagain",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify({ receipt: DataToSend, ebeleg: ebeleg || null }),
        cache: false,
        timeout: 30000,
        success: function (antwort) {
            if (me.debug == 1)
                log.add(1, "Debug B-Kasse", 'receive Hello again response: ', JSON.stringify(antwort));
        },
        error: function (xhr) {
            log.add(1, "Debug B-Kasse", 'error Hello again: ', xhr && xhr.status);
        }
    });
}

export { CHelloAgainAPI };
